export default [
    {
        path: '/routes',
        name: 'Routes',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Routes',
        },
        components: {
            default: () => import('@views/routes/RoutesIndex.vue'),
            agent: () => import('@views/routes/RoutesIndex.vue'),
        },
    },
    {
        path: '/routes/:id/edit',
        name: 'RoutesEdit',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit route',
        },
        props: {
            default: (route) => ({
                id: route.params.id,
                isCreate: false,
            }),
            agent: (route) => ({
                id: route.params.id,
                isCreate: false,
            }),
        },
        components: {
            default: () => import('@views/routes/RoutesEdit.vue'),
            agent: () => import('@views/routes/RoutesEdit.vue'),
        },
    },
    {
        path: '/routes/create',
        name: 'RoutesCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create route',
        },
        props: {
            default: () => ({
                isCreate: true,
            }),
            agent: () => ({
                isCreate: true,
            }),
        },
        components: {
            default: () => import('@views/routes/RoutesEdit.vue'),
            agent: () => import('@views/routes/RoutesEdit.vue'),
        },
    },
];
